import type { RotasDoModulo } from '@/app/rotas';

import { MaintenancePage } from './MaintenancePage';
import { AccessDeniedPage } from './StatusPages';

/**
 * Telas de estado. A pagina nao encontrada nao entra aqui: a rota que pega o resto
 * fica no fim de cada moldura, e quem a poe e o router.
 */
export const rotas: RotasDoModulo = {
  // Tela de estado publica: manutencao.
  avulsas: [{ path: '/manutencao', element: <MaintenancePage /> }],
  moldura: [{ path: '/sem-acesso', element: <AccessDeniedPage /> }],
};
